import { EDITOR_MOBILE_OVERVIEW_CONTAINER_HEIGHT } from '@mentimeter/editor-slides-popover/src/components/AddSlidePopover/AddSlidePopover';
import { Box } from '@mentimeter/ragnar-ui/box';

export const SlidesOverviewLayout = ({
  showHorizontalOverviewList,
  children,
}: { showHorizontalOverviewList: boolean; children: React.ReactNode }) => {
  return showHorizontalOverviewList ? (
    <Box
      id="editor-overview-container"
      width="100%"
      height={EDITOR_MOBILE_OVERVIEW_CONTAINER_HEIGHT}
      flexDirection="row"
      justifyContent="center"
      ml="space2"
    >
      {children}
    </Box>
  ) : (
    children
  );
};
